import { AuthCompany } from 'components/auth'

export function getCompaniesInCompanyGroup(
  company: AuthCompany
): { id: number; name: string }[] {
  if (!company?.companyGroup) {
    return [company]
  }

  return company.companyGroup.companies
}
